import React from 'react';
import i18n from '../../../i18n/i18n';
import { Button, TextField, IconButton, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { wentWrong } from '../../../utils/ToastConfig';
import axios from '../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';

export default class AddResponsiblePerson extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workers: [],
            worker: null,
            radno_mesto: '',
        };
    }

    componentDidMount() {
        this.getByURL('worker/responsibile_person', 'workers');

        const selected = this.props.activityObj && this.props.activityObj.odgovorno_lice;
        if (this.props.editResponsiblePerson && selected) {
            this.setState({
                worker: selected.id_radnik || selected.id || null,
                radno_mesto: selected.radnik_radno_mesto || selected.naziv_radno_mesto || selected.radno_mesto || '',
            });
        }
    }

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(() => wentWrong(i18n.t('Something went wrong, please try again!')));
    }

    handleAdd = () => {
        if (!this.state.worker) {
            wentWrong(i18n.t('Please enter all required fields!'));
            return;
        }

        const selectedWorker = this.state.workers.find(worker => worker.id === Number(this.state.worker));

        const responsiblePerson = {
            id_radnik: Number(this.state.worker),
            radnik_naziv: selectedWorker ? selectedWorker.naziv : '',
            naziv_radno_mesto: selectedWorker ? selectedWorker.naziv_radno_mesto : this.state.radno_mesto,
            radnik_radno_mesto: selectedWorker ? selectedWorker.naziv_radno_mesto : this.state.radno_mesto,
        };

        this.props.handleResponsiblePersonObj(responsiblePerson);
    }

    render() {
        return (
            <div style={{ padding: 20 }}>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} style={{ background: '#04764e' }} className="responsive-dialog-title">
                        {i18n.t('Responsible person')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{ minHeight: '20px' }} />
                        <TextField
                            required
                            label={i18n.t('Worker')}
                            select
                            value={this.state.worker || ''}
                            SelectProps={{ native: true }}
                            InputLabelProps={this.state.worker ? { shrink: true } : null}
                            style={{ width: '100%', marginBottom: '16px', marginTop: '8px' }}
                            onChange={(e) => {
                                const selectedWorker = this.state.workers.find(worker => worker.id === Number(e.target.value));
                                this.setState({
                                    worker: e.target.value,
                                    radno_mesto: selectedWorker ? selectedWorker.naziv_radno_mesto : '',
                                });
                            }}
                        >
                            <option value='' />
                            {this.state.workers.map((worker) => (
                                <option key={worker.id} value={worker.id}>
                                    {worker.naziv} ({worker.naziv_radno_mesto})
                                </option>
                            ))}
                        </TextField>

                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '6px' }}>
                            <Button
                                onClick={this.handleAdd}
                                variant='contained'
                                color='primary'
                                style={{ marginBottom: '8px' }}
                            >
                                {this.props.editResponsiblePerson ? i18n.t('Edit') : i18n.t('Add')}
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}
